import { NAVI_ITEM_LIST, SECTION_CONFIG } from '@constants/index';
import '@css/header.scss';
import { type NaviItem } from '@interface/ICommon';
import { useEffect, useRef, type MouseEvent } from 'react';

export default function Header() {
    const headerRef = useRef<HTMLElement>(null);

    const handleClickLogo = (evt: MouseEvent) => {
        evt.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleClickNaviBtn = (evt: MouseEvent, item: NaviItem) => {
        evt.preventDefault();

        const targetEl = document.querySelector(item.href);
        if (!targetEl) return;

        const posY = targetEl.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: posY + item.offsetY, behavior: 'smooth' });
    };

    useEffect(() => {
        const headerEl = headerRef.current;
        if (!headerEl) return;

        const setHeaderBgOpacity = (scrollTop: number) => {
            const secAboutTop = document.getElementById('about')?.offsetTop ?? 0;
            const secContactTop = document.getElementById('contact')?.offsetTop ?? 0;

            if (scrollTop < secAboutTop) {
                // in main section
                headerEl.style.backgroundColor = SECTION_CONFIG.main.headerBgColor;
            } else if (scrollTop < secContactTop) {
                // in about section
                headerEl.style.backgroundColor = SECTION_CONFIG.about.headerBgColor;
            } else if (scrollTop >= secContactTop) {
                // in contact section
                headerEl.style.backgroundColor = SECTION_CONFIG.contact.headerBgColor;
            }
        };

        const handleScroll = () => setHeaderBgOpacity(window.scrollY);
        window.addEventListener('scroll', handleScroll);

        setHeaderBgOpacity(window.scrollY);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header className="header" ref={headerRef}>
            <div className="header__logo hide-text">
                <a href="#main" onClick={handleClickLogo}>
                    NCV GAMES
                </a>
            </div>
            <div className="header-nav">
                <ul className="header-nav__items">
                    {NAVI_ITEM_LIST.map((item, index) => (
                        <li key={`nav-item-${index}`} className="header-nav__item">
                            <a href={item.href} onClick={(evt: MouseEvent) => handleClickNaviBtn(evt, item)}>
                                {item.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </header>
    );
}
